import type { ComplexBreadcrumbItem } from "../types/complex-breadcrumb-item"
import { AnalyticsPagesComplexBreadcrumbApplicationComponent } from "./complex-breadcrumb-applications/analytics-pages-complex-breadcrumb-application"
import { ClFarmsPagesComplexBreadcrumbApplicationComponent } from "./complex-breadcrumb-applications/cl-farms-pages-complex-breadcrumb-application"
import { ClassicLiquidityPagesComplexBreadcrumbApplicationComponent } from "./complex-breadcrumb-applications/classic-liquidity-pages-complex-breadcrumb-application"
import { LockHomeComplexBreadcrumbApplicationComponent } from "./complex-breadcrumb-applications/lock-home-complex-breadcrumb-application"
import { LockPagesComplexBreadcrumbApplicationComponent } from "./complex-breadcrumb-applications/lock-pages-complex-breadcrumb-application"
import { ManualClV1ManagePagesComplexBreadcrumbApplicationComponent } from "./complex-breadcrumb-applications/manual-cl-v1-manage-pages-complex-breadcrumb-application"
import { ManualClV1PositionComplexBreadcrumbApplicationComponent } from "./complex-breadcrumb-applications/manual-cl-v1-position-complex-breadcrumb-application"
import { ManualClV2ManagePagesComplexBreadcrumbApplicationComponent } from "./complex-breadcrumb-applications/manual-cl-v2-manage-pages-complex-breadcrumb-application"
import { ManualClV2PositionComplexBreadcrumbApplicationComponent } from "./complex-breadcrumb-applications/manual-cl-v2-position-complex-breadcrumb-application"
import { RewardsPagesComplexBreadcrumbApplicationComponent } from "./complex-breadcrumb-applications/rewards-pages-complex-breadcrumb-application"

interface ComplexBreadcrumbRendererProps {
  item: ComplexBreadcrumbItem
}

/**
 * Renders complex breadcrumb items based on their application type
 */
export const ComplexBreadcrumbRenderer = ({ item }: ComplexBreadcrumbRendererProps) => {
  switch (item.application) {
    case "analytics-pages":
      return <AnalyticsPagesComplexBreadcrumbApplicationComponent />
    case "classic-liquidity-pages":
      return <ClassicLiquidityPagesComplexBreadcrumbApplicationComponent />
    case "cl-farms-pages":
      return <ClFarmsPagesComplexBreadcrumbApplicationComponent />
    case "lock-home":
      return <LockHomeComplexBreadcrumbApplicationComponent />
    case "lock-pages":
      return <LockPagesComplexBreadcrumbApplicationComponent />
    case "manual-cl-v1-manage-pages":
      return <ManualClV1ManagePagesComplexBreadcrumbApplicationComponent />
    case "manual-cl-v1-position":
      return <ManualClV1PositionComplexBreadcrumbApplicationComponent />
    case "manual-cl-v2-manage-pages":
      return <ManualClV2ManagePagesComplexBreadcrumbApplicationComponent />
    case "manual-cl-v2-position":
      return <ManualClV2PositionComplexBreadcrumbApplicationComponent />
    case "rewards-pages":
      return <RewardsPagesComplexBreadcrumbApplicationComponent />

    default:
      return <div className="text-red-500">{item.application} - unknown application type</div>
  }
}
